import { render, staticRenderFns } from "./ForgeViewer.vue?vue&type=template&id=a01d0370"
import script from "./ForgeViewer.vue?vue&type=script&lang=js"
export * from "./ForgeViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports